import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-7, 56px);
  width: 100%;
  margin-top: auto;
  background-color: #161515;

  @media (max-width: 1023px) {
    gap: var(--space-5, 40px);
  }

  @media (min-width: 1024px) {
    gap: var(--space-5, 40px);

    padding: var(--space-8, 64px) var(--space-10, 80px) var(--space-5, 40px)
      var(--space-10, 80px);
  }

  @media (min-width: 1440px) {
    gap: var(--space-7, 56px);
  }
`;

export const LegalContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  @media (max-width: 1023px) {
    flex-direction: column;
  }

  @media (min-width: 1024px) {
    justify-content: space-between;
    max-width: 864px;
  }

  @media (min-width: 1440px) {
    max-width: 1280px;
  }
`;

export const Legal = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  width: 100%;
  max-width: 1280px;
  color: var(--color-text-secondary, #c3c3c3);
  font-size: 11px;
  font-weight: 325;
  line-height: 18px; /* 163.636% */
  letter-spacing: 0.22px;

  @media (max-width: 1023px) {
    text-align: center;
    margin-bottom: 40px;
  }

  a {
    color: inherit;
    text-decoration-line: underline;
  }
  p {
    margin: 0;
  }
`;
